var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOcean(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ship_Envirotainer_MOP",
    transform: "matrix(1,0,0,1,-62,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M551.1,333.3c-64.7,0-129.3,0-194,0c-61.4,0-122.8,0-184.2,0c-12.6,0-25.3-11.4-25.6-24.8     c-0.6-31.7-0.2-135.8-0.6-135.8c0-25.5-0.1-27.5-0.1-51.4c-5.1,0-33.8,0.2-33.8,0.2l-0.4,52.5c0,0-30.8-0.2-36-0.2     c0,59.3,0,142.3,0,142.3l-13.6-0.4c0,0-0.1,35.2,0,52.1c0.2,36.2,17.5,59.7,44.9,59.8c131.7,0.2,263.4,0.1,395.1-0.1     c4.2,0,10.1-1.4,12.5-5.2c17.6-28,40.2-55.4,59.5-87.6C566.5,334.7,556,333.3,551.1,333.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.8,
    y: 240.4,
    fill: "#FFFFFF",
    width: 108.2,
    height: 69.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.9,
    y: 240.4,
    fill: "#FFFFFF",
    width: 108.2,
    height: 69.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.5,
    y: 240.4,
    fill: "#FFFFFF",
    width: 108.2,
    height: 69.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcean);
export default __webpack_public_path__ + "static/media/ocean.02efc24bcaeace4f0568bc52d881770c.svg";
export { ForwardRef as ReactComponent };